<template>
  <div class="panel panel-default panel-actions">
    <div class="panel-heading panel-heading-underline">
      <h3 class="panel-title">
        {{ trans("examination.generalHeadline") }}

        <custom-action-handler
          v-if="patientActions?.length"
          :actions="patientActions"
          @on-action="onPatientAction"
        />

        <span v-if="examination" class="actions">
          <button
            v-if="!isEditing && !disableEdit"
            class="btn btn-custom float-right"
            type="button"
            @click.stop="editWound(true)"
          >
            {{ trans("examination.diagnosReplyEditButton") }}
          </button>
          <button
            v-if="isEditing"
            class="btn btn-custom float-right submit"
            type="button"
            @click.stop="submitChanges"
          >
            {{ trans("general.formSaveLabel") }}
          </button>
          <button
            v-if="isEditing"
            class="btn btn-custom float-right cancel"
            type="button"
            @click.stop="editWound(false)"
          >
            {{ trans("general.modalCancelButton") }}
          </button>
        </span>
      </h3>
    </div>
    <div class="panel-body">
      <div class="row">
        <div class="m-b-20 col-md-6">
          <strong>{{ trans("patient.ssn") }}</strong>
          <br />
          <p class="text-muted">{{ patient.ssn }}</p>
        </div>

        <div class="m-b-20 col-md-6">
          <strong>{{ trans("patient.fullName") }}</strong>
          <br />
          <p
            v-dompurify-html:[DOMPURIFY_CONFIG_NAME.fullName]="patient.fullName"
            class="text-muted"
          ></p>
        </div>

        <div class="m-b-20 col-md-6">
          <strong>{{ trans("patient.age") }}</strong>
          <br />
          <p class="text-muted">{{ patient.age }}</p>
        </div>

        <div class="m-b-20 col-md-6">
          <strong>{{ trans("patient.gender") }}</strong>
          <br />
          <p class="text-muted">{{ patient.gender }}</p>
        </div>

        <div class="m-b-20 col-md-6">
          <strong>{{ trans("patient.patientViewLastUpdated") }}</strong>
          <br />
          <p v-if="examination" class="text-muted">
            {{ examination.createdAt }}
          </p>
        </div>

        <div class="m-b-20 col-md-6">
          <strong>{{ trans("examination.centerLabel") }}</strong>
          <br />
          <p v-if="examination" class="text-muted">
            {{ examination.center }}
          </p>
        </div>

        <div class="m-b-20 col-md-6">
          <strong>{{ trans("patient.patientViewUpdatedBy") }}</strong>
          <br />
          <p v-if="examination" class="text-muted">
            {{ examination.createdUser }}
          </p>
        </div>
      </div>
    </div>

    <CdrFlagDialog
      v-if="patient"
      :show="showCdrFlagDialog"
      :target-type="cdrScopeType.PATIENT"
      :target-id="Number($route.params.id)"
      @close="showCdrFlagDialog = false"
      @created="showCdrFlagDialog = false"
    />
  </div>
</template>

<script>
import { DOMPURIFY_CONFIG_NAME } from "../../dompurify";
import CustomActionHandler from "../Examinations/Examination/ExaminationComponents/components/CustomActionHandler.vue";
import CdrFlagDialog from "../ClinicalDataRemoval/CdrFlagDialog.vue";
import { CDR_SCOPE_TYPE } from "../ClinicalDataRemoval/cdr-constants";

export default {
  components: {
    CustomActionHandler,
    CdrFlagDialog,
  },
  props: {
    examination: {
      age: String,
      gender: String,
      createdAt: String,
      center: String,
      createdUser: String,
    },
    patient: {
      gender: String,
      age: String,
      fullName: String,
      ssn: String,
    },
    isEditing: Boolean,
    disableEdit: Boolean,
  },
  data() {
    return {
      DOMPURIFY_CONFIG_NAME,
      showCdrFlagDialog: false,
      cdrScopeType: CDR_SCOPE_TYPE,
    };
  },
  computed: {
    patientActions() {
      if (this.patient?.hasPatientLevelCdrFlag) return [];
      return [
        {
          name: "cdr_report_patient",
          title: this.trans("admin.cdr.reportPatient"),
        },
      ];
    },
  },
  methods: {
    editWound: function (bool) {
      this.$emit("editWound", bool);
    },
    submitChanges: function () {
      this.$emit("submitWoundChanges");
    },
    onPatientAction: function (action) {
      if (action.name === "cdr_report_patient") {
        this.showCdrFlagDialog = true;
      }
    },
  },
};
</script>
